<template>
  <div class="wrapper">
    <div class="main visual-2 appoint-approval-main">
      <Header :backRoute="'/appointments'" />

      <div class="approval-tables">
        <!-- Tabs -->
        <div class="approval-btn">
          <button
            :class="{ active: activeTab === 'approved' }"
            @click="changeTab('approved')"
          >
            Approved Appointments
          </button>

          <button
            :class="{ active: activeTab === 'notApproved' }"
            @click="changeTab('notApproved')"
          >
            Not Approved Appointments
          </button>

          <button
            :class="{ active: activeTab === 'cancelled' }"
            @click="changeTab('cancelled')"
          >
            Cancelled Appointments
          </button>
        </div>

        <!-- Loader -->
        <div v-if="loading" class="loader">Loading...</div>

        <div v-else class="approval-table-section">
          <!-- Approved Appointments Table -->
          <div v-if="activeTab === 'approved'" class="table-1">
            <div class="queue-table-container">
              <div class="queue-table-wrapper">
                <table class="queue-table">
                  <thead>
                    <tr>
                      <th>Patient Name</th>
                      <th>Appointment ID</th>
                      <th>Approved Date</th>
                      <th>Approved Time</th>
                      <th>Doctor Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(appointment, index) in appointments"
                      :key="index"
                    >
                      <td>{{ formatFullName(appointment?.patient) }}</td>
                      <td>{{ appointment?.appointmentCode }}</td>
                      <td>
                        {{
                          formatDate(
                            appointment?.assignedStartTime,
                            appointment,
                          )
                        }}
                      </td>
                      <td>
                        {{
                          timeFormat(
                            appointment?.assignedStartTime,
                            appointment,
                          )
                        }}
                      </td>
                      <td>{{ formatFullName(appointment?.doctor) }}</td>
                      <td>
                        <p :class="statusClass(appointment?.status)">
                          {{ appointment?.status }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Not Approved Appointments Table -->
          <div v-else-if="activeTab === 'notApproved'" class="table-2">
            <div class="queue-table-container">
              <div class="queue-table-wrapper">
                <table class="queue-table">
                  <thead>
                    <tr>
                      <th>Patient Name</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Doctor Name</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(appointment, index) in appointments"
                      :key="index"
                    >
                      <td>{{ formatFullName(appointment?.patient) }}</td>
                      <td>
                        {{
                          showDate(appointment?.assignedStartTime, appointment)
                        }}
                      </td>
                      <td>
                        {{
                          formatTimeSlot({
                            startTime: appointment.assignedStartTime,
                            endTime: appointment.assignedEndTime,
                            assignDate:
                              appointment.assignDate ||
                              appointment.assignedDate,
                          })
                        }}
                      </td>
                      <td>{{ formatFullName(appointment?.doctor) }}</td>
                      <td>
                        <p
                          class="btn btn-primary"
                          @click="openModal(appointment)"
                        >
                          Approve
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Cancelled Appointments Table -->
          <div v-else-if="activeTab === 'cancelled'" class="table-1">
            <div class="queue-table-container">
              <div class="queue-table-wrapper">
                <table class="queue-table">
                  <thead>
                    <tr>
                      <th>Patient Name</th>
                      <th>Appointment ID</th>
                      <th>Cancelled Date</th>
                      <th>Cancelled Time</th>
                      <th>Doctor Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(appointment, index) in appointments"
                      :key="index"
                    >
                      <td>{{ formatFullName(appointment?.patient) }}</td>
                      <td>{{ appointment?.appointmentCode }}</td>
                      <td>
                        {{
                          formatDate(
                            appointment?.assignedStartTime,
                            appointment,
                          )
                        }}
                      </td>
                      <td>
                        {{
                          timeFormat(
                            appointment?.assignedStartTime,
                            appointment,
                          )
                        }}
                      </td>
                      <td>{{ formatFullName(appointment?.doctor) }}</td>
                      <td>
                        <p :class="statusClass(appointment?.status)">
                          {{ appointment?.status }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!--
          <div v-if="totalPages > 0" class="pagination-section">
            <div class="pagination-info flex">
              <p>
                Showing
                <strong>{{ totalItems > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0 }}</strong>
                to
                <strong>{{ Math.min(currentPage * itemsPerPage, totalItems) }}</strong>
                of <strong>{{ totalItems }}</strong> appointments
              </p>
              <div class="items-per-page">
                <label>Per Page:</label>
                <select :value="itemsPerPage" @change="changeItemsPerPage(Number($event.target.value))"
                  class="items-select">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                </select>
              </div>
            </div>

            <div class="pagination-controls">
              <button class="pagination-btn" @click="previousPage" :disabled="currentPage === 1">
                ← Previous
              </button>

              <div class="pagination-numbers">
                <button v-for="page in getPageNumbers()" :key="page"
                  :class="['pagination-number', { active: currentPage === page }]" @click="goToPage(page)">
                  {{ page }}
                </button>
              </div>

              <button class="pagination-btn" @click="nextPage" :disabled="currentPage === totalPages">
                Next →
              </button>
            </div>
          </div>
          -->
        </div>
      </div>

      <FooterView />
    </div>
  </div>

  <!-- Modal -->
  <div v-if="showModal" id="cancelCheckinModal" class="modal modalDesign">
    <div class="modal-content">
      <button class="close-btn" @click="showModal = false">&times;</button>
      <h3>Appointment Status</h3>
      <div class="modal-footer">
        <button
          class="btn btn-primary"
          @click="updateAppointmentStatus('approved')"
          :disabled="isLoading"
        >
          Approve
          <span
            v-if="isLoading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
        <button
          class="btn btn-danger"
          @click="updateAppointmentStatus('cancelled')"
          :disabled="isLoading"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { AppointmentService } from "@/services/appointments.service";
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  data() {
    return {
      activeTab: "approved",
      appointments: [],
      loading: false,
      showModal: false,
      selectedAppointment: null,
      selectedDate: null,
      timeSlots: [],
      selectedTimeSlot: null,
      message: "",
      isLoading: false,
      id: "",
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0,
      totalPages: 1,
      hasNextPage: false,
      hasPreviousPage: false,
    };
  },
  computed: {
    tableTitle() {
      if (this.activeTab === "approved") return "Approved Appointments";
      if (this.activeTab === "notApproved") return "Not Approved Appointments";
      return "Cancelled Appointments";
    },
  },
  methods: {
    isTimeOnly(value) {
      return typeof value === "string" && /^\d{2}:\d{2}(:\d{2})?$/.test(value);
    },
    parseAppointmentDateTime(dateTime, appointment = {}) {
      if (!dateTime) return null;

      if (this.isTimeOnly(dateTime)) {
        const assignedDate =
          appointment?.assignDate || appointment?.assignedDate;
        if (assignedDate) {
          const withSeconds =
            dateTime.length === 5 ? `${dateTime}:00` : dateTime;
          const combined = new Date(`${assignedDate}T${withSeconds}`);
          if (!Number.isNaN(combined.getTime())) return combined;
        }
      }

      const parsed = new Date(dateTime);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    formatFullName(person, limit = 20) {
      if (!person) return "";

      // Handle both object and string name formats
      let first = person.firstName || person.firstname || "";
      let last = person.lastName || person.lastname || "";

      const capitalizeWord = (value) =>
        (value || "")
          .toString()
          .toLowerCase()
          .replace(/\b\w/g, (char) => char.toUpperCase());

      first = capitalizeWord(first);
      last = capitalizeWord(last);

      let fullName = `${first} ${last}`.trim();

      // Limit the name length (optional)
      if (fullName.length > limit) {
        fullName = fullName.substring(0, limit).trim() + "...";
      }

      return fullName;
    },
    convertTo12Hour(time24) {
      let [hours, minutes] = time24.split(":").map(Number);
      let period = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
    },
    parseLocalDateOnly(value) {
      if (!value) return null;

      const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;

      const [, year, month, day] = match;
      return new Date(Number(year), Number(month) - 1, Number(day));
    },
    convertToLocalTime(date, time) {
      if (!time) return null;

      let localDate = this.parseLocalDateOnly(date) || new Date();

      // ISO format
      if (time.includes("T")) {
        const [isoDatePart, timePart] = time.split("T");
        const parsedDate = this.parseLocalDateOnly(isoDatePart);
        if (parsedDate) {
          localDate = parsedDate;
        }

        const clockMatch = String(timePart || "").match(/^(\d{2}):(\d{2})/);
        if (!clockMatch) return null;

        let [, hours, minutes] = clockMatch;
        hours = Number(hours) - 6;
        minutes = Number(minutes);

        localDate.setHours(hours, minutes, 0, 0);
        return localDate;
      } else {
        const parts = time.split(":");
        if (parts.length < 2) return null;

        let [hours, minutes] = parts.map(Number);
        if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

        localDate.setHours(hours, minutes, 0, 0);
        localDate.setHours(localDate.getHours() - 6);
        return localDate;
      }
    },
    formatTimeDisplay(time, date = null) {
      if (!time) return "";

      const localDate = this.convertToLocalTime(date, time);
      if (!localDate) return "";

      return localDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    timeFormat(dateTime, appointment = {}) {
      return this.formatTimeDisplay(
        dateTime,
        appointment?.assignDate || appointment?.assignedDate,
      );
    },
    formatTimeSlot(slot) {
      const assignedDate = slot.assignDate || slot.assignedDate;
      const startTime = this.formatTimeDisplay(slot.startTime, assignedDate);
      const endTime = this.formatTimeDisplay(slot.endTime, assignedDate);

      if (!startTime || !endTime) return "";

      return `${startTime} - ${endTime}`;
    },
    formatDate(dateString, appointment = {}) {
      const date = this.parseAppointmentDateTime(dateString, appointment);
      if (!date) return "";
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    showDate(utcDate, appointment = {}) {
      if (!utcDate) return "";

      const localDate = this.parseAppointmentDateTime(utcDate, appointment);
      if (!localDate) return "";
      const day = String(localDate.getDate()).padStart(2, "0");
      const month = localDate.toLocaleString("en-US", { month: "short" }); // Get short month name (e.g., Feb)
      const year = localDate.getFullYear();

      return `${day} ${month} ${year}`;
    },

    statusClass(status) {
      switch (status) {
        case "open":
          return "status-open";
        case "waiting":
          return "status-waiting";
        case "cancelled":
          return "status-cancelled";
        case "closed":
          return "status-closed";
        case "approved":
          return "status-approved";
        case "started":
          return "status-started";
        case "inprogress":
          return "status-inprogress";
        case "completed":
          return "status-completed";
        default:
          return "status-default";
      }
    },
    changeTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab;
        this.currentPage = 1;
        this.getAppointments();
      }
    },

    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getAppointments();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
        this.getAppointments();
      }
    },

    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.getAppointments();
      }
    },

    changeItemsPerPage(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.currentPage = 1;
      this.getAppointments();
    },

    getPageNumbers() {
      const pages = [];
      const maxVisiblePages = 5;
      let startPage = Math.max(
        1,
        this.currentPage - Math.floor(maxVisiblePages / 2),
      );
      let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    },

    async updateAppointmentStatus(status) {
      try {
        if (!this.selectedAppointment) return;
        this.isLoading = true;
        const response = await AppointmentService.approveAppointment(
          this.selectedAppointment.id,
          {
            status,
          },
        );

        if (response.success) {
          this.showModal = false;
          this.getAppointments();
          this.$store.commit("toast/NEW", {
            type: "success",
            message: `Appointment ${status} successfully.`,
          });
        } else {
          this.$store.commit("toast/NEW", {
            type: "error",
            message: response.message,
          });
        }
      } catch (error) {
        console.error(`Error updating appointment status to ${status}:`, error);
        this.$store.commit("toast/NEW", {
          type: "error",
          message: `Failed to ${status} appointment. Please try again.`,
        });
      } finally {
        this.isLoading = false;
      }
    },
    openModal(appointment) {
      this.selectedAppointment = appointment;
      this.selectedDate = null;
      this.timeSlots = [];
      this.selectedTimeSlot = null;
      this.showModal = true;
    },
    async getAppointments() {
      this.loading = true;

      try {
        let data = [];
        const now = new Date();
        now.setHours(0, 0, 0, 0);

        if (this.activeTab === "approved") {
          const res = await AppointmentService.getListV2({
            status: "approved",
            page: this.currentPage,
            limit: this.itemsPerPage,
          });
          if (res.data) {
            data = res?.data?.appointments?.filter((a) => {
              const date = this.parseAppointmentDateTime(
                a.assignedStartTime,
                a,
              );
              if (!date) return false;
              date.setHours(0, 0, 0, 0);
              return date >= now;
            });
          }
          this.applyPagination(res);
        } else if (this.activeTab === "notApproved") {
          const res = await AppointmentService.getList({
            status: "open",
            page: this.currentPage,
            limit: this.itemsPerPage,
          });
          if (res.data) data = res?.data?.appointments;
          this.applyPagination(res);
        } else if (this.activeTab === "cancelled") {
          const res = await AppointmentService.getList({
            status: "cancelled",
            page: this.currentPage,
            limit: this.itemsPerPage,
          });
          if (res.data) {
            data = res?.data?.appointments?.filter((a) => {
              const date = this.parseAppointmentDateTime(
                a.assignedStartTime,
                a,
              );
              if (!date) return false;
              date.setHours(0, 0, 0, 0);
              return date >= now;
            });
          }
          this.applyPagination(res);
        }

        // Sort by date ascending
        data.sort((a, b) => {
          const aDate = this.parseAppointmentDateTime(a.assignedStartTime, a);
          const bDate = this.parseAppointmentDateTime(b.assignedStartTime, b);

          if (!aDate && !bDate) return 0;
          if (!aDate) return 1;
          if (!bDate) return -1;
          return aDate - bDate;
        });

        this.appointments = data;
      } catch (error) {
        console.error("Error fetching appointments:", error);
        this.$store.commit("toast/NEW", {
          type: "error",
          message: "Failed to load appointments. Please try again.",
        });
      } finally {
        this.loading = false;
      }
    },

    applyPagination(res) {
      const pagination = res?.data?.pagination || res?.pagination || null;

      if (!pagination) {
        this.totalItems = this.appointments.length || 0;
        this.totalPages = 1;
        this.hasNextPage = false;
        this.hasPreviousPage = false;
        return;
      }

      this.totalItems = pagination.totalCount || pagination.totalItems || 0;
      this.totalPages = pagination.totalPages || 1;
      this.currentPage = pagination.currentPage || this.currentPage;
      this.hasNextPage = this.currentPage < this.totalPages;
      this.hasPreviousPage = this.currentPage > 1;
    },
    // async getAppointments() {
    //   this.loading = true;
    //   const response = await AppointmentService.getList({
    //     status: this.activeTab === "approved" ? "approved" : "open",
    //   });
    //   if (response.success) this.appointments = response.data;
    //   this.loading = false;
    // },
  },
  created() {
    this.getAppointments();
  },
};
</script>

<style scoped>
.approval-table-section {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.approval-tables {
  width: min(1400px, calc(100% - 40px));
  margin: 12px auto 0;
  flex: 1;
  padding-bottom: 150px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #eee;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.table-header h3 {
  margin: 0;
  color: #2c3e50;
}

.items-per-page {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #7f8c8d;
}

.items-select {
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  background: white;
  color: #2c3e50;
}

.items-select:focus {
  outline: none;
  border-color: #007bff;
}

.pagination-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 25px;
  border-top: 1px solid #eee;
  background: #fafbfc;
}

.pagination-info {
  font-size: 13px;
  color: #7f8c8d;
}

.pagination-info.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.pagination-info p {
  margin: 0;
}

.pagination-info strong {
  color: #2c3e50;
  font-weight: 600;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pagination-btn {
  padding: 8px 14px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  background: white;
  color: #007bff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.pagination-btn:hover:not(:disabled) {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.pagination-btn:disabled {
  color: #bbb;
  cursor: not-allowed;
  opacity: 0.5;
}

.pagination-numbers {
  display: flex;
  gap: 4px;
}

.pagination-number {
  width: 36px;
  height: 36px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  background: white;
  color: #2c3e50;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-number:hover:not(.active) {
  border-color: #007bff;
  color: #007bff;
}

.pagination-number.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
}

.close-btn {
  position: absolute;
  top: -22px;
  right: 2px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  font-size: 50px;
}

.close-btn:hover {
  color: red;
}

.appoint-approval-main {
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 150px;
  padding-bottom: 0;
}

.appoint-approval-main :deep(.bck-btns) {
  z-index: 10;
}

@media (max-width: 600px) {
  .approval-tables {
    width: calc(100% - 20px);
    margin-top: 8px;
    padding-bottom: 130px;
  }

  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .pagination-info.flex {
    flex-direction: column;
    align-items: flex-start;
  }

  .pagination-controls {
    flex-direction: column;
  }

  .pagination-numbers {
    justify-content: center;
  }

  .pagination-btn {
    width: 100%;
  }

  .pagination-section {
    gap: 12px;
    padding: 15px;
  }
}
</style>
